<template>
	<DialogControl :model-value="modelValue" :title="title || t('Image')" icon="image" :fullscreen="fullscreen" :attach="overlayTarget || undefined" max-width="960" :class="['image-viewer-dialog', { 'image-viewer-dialog--fullscreen': fullscreen }]" body-class="image-viewer-dialog__body" @update:model-value="(value) => emit('update:modelValue', value)">
		<template #title-append>
			<v-btn icon variant="text" size="small" :disabled="!url" @click="zoom(ZOOM_STEP)">
				<v-icon>add</v-icon>
			</v-btn>
			<v-btn icon variant="text" size="small" :disabled="!url || scale <= 1" @click="zoom(-ZOOM_STEP)">
				<v-icon>remove</v-icon>
			</v-btn>
			<v-btn icon variant="text" size="small" @click="fullscreen = !fullscreen">
				<v-icon>{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
			</v-btn>
		</template>
		<v-progress-circular v-if="loading" indeterminate color="primary" />
		<img v-else-if="url" :src="url" alt="" class="image-viewer-dialog__image" :style="{ transform: `scale(${scale})` }" />
	</DialogControl>
</template>

<script setup>
import { inject, ref, watch } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';
import { useTranslator } from '@/composables/useTranslator';

const ZOOM_STEP = 0.5;

const props = defineProps({
	modelValue: { type: Boolean, default: false },
	url: { type: String, default: null },
	loading: { type: Boolean, default: false },
	title: { type: String, default: null },
});
const emit = defineEmits(['update:modelValue']);

const t = useTranslator();
const overlayTarget = inject('overlayTarget', null);
const scale = ref(1);
const fullscreen = ref(false);

watch(
	() => [props.modelValue, props.url],
	() => {
		scale.value = 1;
	}
);

watch(
	() => props.modelValue,
	(open) => {
		if (!open) fullscreen.value = false;
	}
);

const zoom = (step) => {
	scale.value = Math.min(4, Math.max(1, scale.value + step));
};
</script>
